(function () {
  const root = document.querySelector("[data-my-packs-root]");
  if (!root) return;

  const apiBase = root.dataset.apiBase;
  const customerId = root.dataset.customerId;
  const statusEl = root.querySelector("[data-my-packs-status]");
  const tabsEl = root.querySelector("[data-my-packs-tabs]");
  const refreshButton = root.querySelector("[data-my-packs-refresh]");
  const tabButtons = root.querySelectorAll("[data-pack-tab]");
  const countEls = {
    unopened: root.querySelector('[data-pack-count="unopened"]'),
    opened: root.querySelector('[data-pack-count="opened"]')
  };
  const panels = {
    unopened: root.querySelector('[data-pack-panel="unopened"]'),
    opened: root.querySelector('[data-pack-panel="opened"]')
  };
  const grids = {
    unopened: root.querySelector('[data-my-packs-grid="unopened"]'),
    opened: root.querySelector('[data-my-packs-grid="opened"]')
  };
  const emptyEls = {
    unopened: root.querySelector('[data-my-packs-empty="unopened"]'),
    opened: root.querySelector('[data-my-packs-empty="opened"]')
  };
  const modal = root.querySelector("[data-pack-modal]");
  const modalCloseButtons = root.querySelectorAll("[data-pack-modal-close]");
  const modalStatus = root.querySelector("[data-pack-modal-status]");
  const packTitle = root.querySelector("[data-pack-title]");
  const packSubtitle = root.querySelector("[data-pack-subtitle]");
  const packFoil = root.querySelector("[data-pack-foil]");
  const packFoilTitle = root.querySelector("[data-pack-foil-title]");
  const packConfirm = root.querySelector("[data-pack-confirm]");
  const packMessage = root.querySelector("[data-pack-message]");
  const packResult = root.querySelector("[data-pack-result]");

  const state = {
    activeTab: "unopened",
    packs: {
      unopened: [],
      opened: []
    }
  };
  let selectedPack = null;
  let lightboxEl = null;
  let activePayload = null;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function showStatus(message) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function hideStatus() {
    if (statusEl) statusEl.hidden = true;
  }

  function endpoint(path) {
    return `${apiBase.replace(/\/$/, "")}${path}`;
  }

  function customerPath(path) {
    if (!customerId) return path;
    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}customer_id=${encodeURIComponent(customerId)}`;
  }

  async function request(path, options) {
    const response = await fetch(endpoint(customerPath(path)), {
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        ...(options && options.headers ? options.headers : {})
      },
      ...options
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.error || "Die Anfrage konnte nicht verarbeitet werden.");
    }
    return payload;
  }

  function formatDate(value) {
    if (!value) return "";
    return new Intl.DateTimeFormat("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).format(new Date(value));
  }

  function slugify(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\u00df/g, "ss")
      .replace(/\u00e4/g, "ae")
      .replace(/\u00f6/g, "oe")
      .replace(/\u00fc/g, "ue")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function albumHrefForPack(pack) {
    const key = slugify(pack.edition || pack.editionName);
    if (!key) return "/pages/sammelheft-auswahl";
    return `/pages/sammelheft-${encodeURIComponent(key)}`;
  }

  function packAnimationHref(pack) {
    const packId = pack && (pack.id || pack.pack_id || pack.packId);
    if (!packId) return "/pages/packanimation";
    const returnTo = `${window.location.pathname || "/pages/meine-packs"}${window.location.search || ""}`;
    return `/pages/packanimation?my_pack_id=${encodeURIComponent(packId)}&return_to=${encodeURIComponent(returnTo)}`;
  }

  function goToPackAnimation(pack) {
    window.location.href = packAnimationHref(pack);
  }

  function packStatus(pack) {
    if (pack.status === "opened") {
      return { label: "Schon ge\u00f6ffnet", className: "is-opened", action: "Karten ansehen", disabled: false };
    }
    return { label: "Bereit zum \u00d6ffnen", className: "is-ready", action: "Jetzt Pack \u00f6ffnen", disabled: false };
  }

  function packTypeKey(pack) {
    const raw = String(pack.packType || pack.pack_type || pack.packLabel || "").trim().toLowerCase();
    if (raw.includes("one") || raw.includes("piece")) return "one_piece";
    if (raw.includes("pokemon") || raw.includes("pokémon")) return "pokemon";
    return raw.replace(/[^a-z0-9]+/g, "_") || "pack";
  }

  function packTypeLabel(pack) {
    const key = packTypeKey(pack);
    if (key === "one_piece") return "One Piece";
    if (key === "pokemon") return "Pokemon";
    return String(pack.packLabel || "Pack").replace(/\s*#\d+\s*$/, "").trim() || "Pack";
  }

  function packSortTime(pack) {
    const parsed = Date.parse(pack.createdAt || pack.created_at || "");
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function packSortId(pack) {
    const raw = pack.id || pack.pack_id || pack.packId || pack.booster_id || 0;
    const parsed = Number(String(raw).replace(/\D+/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function packDisplayLabel(pack) {
    return pack.displayPackLabel || pack.packLabel || `Pack ${pack.packIndex || 1}`;
  }

  function applyCustomerPackNumbers(packs) {
    const normalized = {
      unopened: packs.unopened || [],
      opened: packs.opened || []
    };
    const all = [...normalized.unopened, ...normalized.opened];
    const groups = {};

    all.forEach((pack) => {
      const key = packTypeKey(pack);
      groups[key] = groups[key] || [];
      groups[key].push(pack);
    });

    Object.values(groups).forEach((group) => {
      group
        .sort((left, right) => (
          packSortTime(left) - packSortTime(right)
          || packSortId(left) - packSortId(right)
        ))
        .forEach((pack, index) => {
          const number = index + 1;
          pack.customerPackNumber = number;
          pack.displayPackLabel = `${packTypeLabel(pack)} #${number}`;
        });
    });

    return normalized;
  }

  function hitLabel(level) {
    const labels = {
      1: "Reverse",
      2: "Silver Hit",
      3: "Red Hit",
      4: "Gold Hit",
      5: "Lightblue Hit"
    };
    return labels[Number(level)] || (Number(level) > 0 ? `Hit ${level}` : "Karte");
  }

  function normalizeEraText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\u00df/g, "ss")
      .replace(/\u00e4/g, "ae")
      .replace(/\u00f6/g, "oe")
      .replace(/\u00fc/g, "ue")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "");
  }

  function isPokemonPack(payload) {
    const pack = payload?.pack || payload || {};
    const raw = [
      pack.packType,
      pack.pack_type,
      pack.packLabel,
      payload?.pack_type
    ].map(normalizeEraText).join(" ");
    if (raw.includes("onepiece")) return false;
    if (raw.includes("pokemon") || raw.includes("pokmon") || raw.includes("poke")) return true;
    return true;
  }

  function packEraText(payload) {
    const pack = payload?.pack || payload || {};
    return [
      pack.editionName,
      pack.edition,
      pack.packLabel,
      payload?.editionName,
      payload?.edition,
      payload?.cover
    ].map(normalizeEraText).join(" ");
  }

  function isMysteryBoosterEdition(payload) {
    const text = packEraText(payload);
    return text.includes("mysterybooster") || text.includes("mysterbooster");
  }

  function isVividVoltageEdition(payload) {
    const text = packEraText(payload);
    return text.includes("vividvoltage") || text.includes("farbenschock");
  }

  function slotRoleForPosition(payload, position, animation) {
    const idx = Number(position || 0);
    const level = Number(animation || 0);
    if (!isPokemonPack(payload)) return null;
    if (isMysteryBoosterEdition(payload)) return null;
    if (isVividVoltageEdition(payload)) {
      if (idx === 9) return { label: "Reverse/Hit", className: level > 1 ? "hit" : "reverse" };
      if (idx === 10) return { label: "Rare/Hit", className: "rare" };
      return null;
    }
    if (idx === 8 || idx === 9) return { label: "Reverse/Hit", className: level > 1 ? "hit" : "reverse" };
    if (idx === 10) return { label: "Rare/Hit", className: "rare" };
    return null;
  }

  function normalizeCardItem(card, fallbackPosition) {
    const position = Number(card.position || card.idx || fallbackPosition || 0);
    const animation = Number(card.animation || card.animId || card.Animation || 0);
    return {
      ...card,
      position,
      animation,
      imageUrl: card.imageUrl || card.img || card.url || card.image || "",
      name: card.name || card.cardName || (position ? `Karte ${position}` : "Karte"),
      rarity: card.rarity || hitLabel(animation)
    };
  }

  function normalizeCards(payloadOrCards) {
    const payload = payloadOrCards || {};
    if (Array.isArray(payload)) return payload.map((card, index) => normalizeCardItem(card, index + 1));
    if (Array.isArray(payload.cards)) return payload.cards.map((card, index) => normalizeCardItem(card, index + 1));

    const cards = payload.cards || {};
    const names = payload.names || {};
    if (!cards || typeof cards !== "object") return [];

    return Object.keys(cards)
      .map((key) => {
        const match = key.match(/(\d+)$/);
        const position = match ? Number(match[1]) : 0;
        const animation = Number(payload[`Animation_${position}`] || 0);
        const slotRole = slotRoleForPosition(payload, position, animation);
        return {
          position,
          animation,
          slotRole,
          imageUrl: cards[key],
          name: names[`name_${position}`] || names[key.replace("card_", "name_")] || `Karte ${position || ""}`.trim(),
          rarity: slotRole ? slotRole.label : hitLabel(animation)
        };
      })
      .sort((left, right) => left.position - right.position);
  }

  function renderPackCard(pack, type) {
    const status = packStatus(pack);
    const meta = [
      pack.orderName || pack.orderId ? `Bestellung ${pack.orderName || pack.orderId}` : "",
      pack.createdAt ? formatDate(pack.createdAt) : ""
    ].filter(Boolean).map(escapeHtml).join(" &middot; ");
    const label = packDisplayLabel(pack);
    const albumHref = albumHrefForPack(pack);
    const cover = pack.cover
      ? `<img class="pack-card__cover" src="${escapeHtml(pack.cover)}" alt="${escapeHtml(pack.editionName || "Online Booster")}">`
      : "";

    const card = document.createElement("article");
    card.className = "pack-card";
    card.tabIndex = 0;
    card.setAttribute("role", "button");
    card.setAttribute("aria-label", `${label} ansehen`);
    card.innerHTML = `
      <div class="pack-card__art">
        ${cover}
        <span>${escapeHtml(pack.editionName || "Online Booster")}</span>
      </div>
      <div class="pack-card__body">
        <span class="pack-card__status ${status.className}">${escapeHtml(status.label)}</span>
        <p class="pack-card__meta">${meta}</p>
        <h2 class="pack-card__title">${escapeHtml(label)}</h2>
        <p class="pack-card__meta">${escapeHtml(pack.cardCount || 0)} Karten ${pack.sourceLocation ? "&middot; " + escapeHtml(pack.sourceLocation) : ""}</p>
        <div class="pack-card__actions">
          <button class="pack-card__button ${type === "opened" ? "is-secondary" : ""}" type="button" ${status.disabled ? "disabled" : ""}>
            ${escapeHtml(status.action)}
          </button>
          <a class="pack-card__link" href="${escapeHtml(albumHref)}">Zum Sammelheft</a>
        </div>
      </div>
    `;

    const button = card.querySelector("button");
    const link = card.querySelector("a");
    const handleCardAction = () => {
      if (type === "unopened") {
        goToPackAnimation(pack);
        return;
      }
      openModal(pack);
    };

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      handleCardAction();
    });
    link.addEventListener("click", (event) => event.stopPropagation());
    card.addEventListener("click", handleCardAction);
    card.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleCardAction();
      }
    });
    return card;
  }

  function renderPanel(type) {
    const packs = state.packs[type] || [];
    const grid = grids[type];
    const empty = emptyEls[type];

    grid.innerHTML = "";
    if (!packs.length) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;
    packs.forEach((pack, index) => {
      const card = renderPackCard(pack, type);
      card.style.setProperty("--pack-delay", `${Math.min(index * 42, 240)}ms`);
      grid.appendChild(card);
    });
  }

  function setActiveTab(type) {
    state.activeTab = type;
    Object.entries(panels).forEach(([panelType, panel]) => {
      panel.hidden = panelType !== type;
    });
    tabButtons.forEach((button) => {
      const isActive = button.dataset.packTab === type;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", String(isActive));
    });
  }

  function renderPacks() {
    countEls.unopened.textContent = state.packs.unopened.length;
    countEls.opened.textContent = state.packs.opened.length;
    renderPanel("unopened");
    renderPanel("opened");
    tabsEl.hidden = false;
    setActiveTab(state.activeTab);
  }

  async function loadPacks() {
    if (!customerId) return;
    if (!apiBase) {
      showStatus("Der API-Basispfad fehlt noch. Bitte Section-Einstellungen prüfen.");
      return;
    }

    refreshButton && (refreshButton.disabled = true);
    root.classList.add("is-loading");
    root.setAttribute("aria-busy", "true");
    showStatus("Packs werden geladen ...");

    try {
      const payload = await request("/my_packs");
      const numberedPacks = applyCustomerPackNumbers(payload.packs || {});
      state.packs.unopened = numberedPacks.unopened;
      state.packs.opened = numberedPacks.opened;
      renderPacks();
      hideStatus();
    } catch (error) {
      showStatus(error.message);
    } finally {
      refreshButton && (refreshButton.disabled = false);
      root.classList.remove("is-loading");
      root.removeAttribute("aria-busy");
    }
  }

  function resetModal(pack) {
    selectedPack = pack;
    modal.classList.remove("is-showing-result");
    modalStatus.textContent = pack.status === "opened" ? "Schon ge\u00f6ffnet" : "Online Booster";
    packTitle.textContent = pack.editionName || "Online Booster";
    packSubtitle.textContent = packDisplayLabel(pack);
    packFoilTitle.textContent = pack.editionName || "Online Booster";
    if (pack.cover) {
      packFoil.style.backgroundImage = `linear-gradient(125deg, rgba(255,255,255,0.2), transparent 42%), url("${pack.cover}")`;
    } else {
      packFoil.style.backgroundImage = "";
    }
    packFoil.hidden = false;
    packFoil.classList.remove("is-opening");
    packConfirm.hidden = true;
    packConfirm.disabled = false;
    packConfirm.textContent = "Jetzt Pack \u00f6ffnen";
    packMessage.hidden = true;
    packMessage.textContent = "";
    packResult.hidden = true;
    packResult.innerHTML = "";
    activePayload = null;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
  }

  function openModal(pack) {
    resetModal(pack);

    if (pack.status === "opened") {
      packFoil.hidden = true;
      packConfirm.hidden = true;
      packMessage.hidden = false;
      packMessage.textContent = "Karten werden geladen ...";
      showOpenedPack(pack.id);
      return;
    }

    packConfirm.hidden = false;
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    selectedPack = null;
  }

  function createSummaryActions(payload) {
    const actions = document.createElement("div");
    actions.className = "pack-summary-actions";
    actions.innerHTML = `
      <button class="pack-summary-actions__button" type="button">Pack nochmal \u00f6ffnen</button>
    `;
    actions.querySelector("button").addEventListener("click", () => goToPackAnimation(payload.pack || selectedPack || {}));
    return actions;
  }

  function ensureLightbox() {
    if (lightboxEl) return lightboxEl;
    lightboxEl = document.createElement("div");
    lightboxEl.className = "card-lightbox";
    lightboxEl.hidden = true;
    lightboxEl.innerHTML = `
      <button class="card-lightbox__backdrop" type="button" aria-label="Schließen"></button>
      <div class="card-lightbox__panel" role="dialog" aria-modal="true" aria-label="Karte ansehen">
        <button class="card-lightbox__close" type="button" aria-label="Schließen">&times;</button>
        <img class="card-lightbox__image" alt="">
        <div class="card-lightbox__text">
          <p class="card-lightbox__rarity"></p>
          <h3 class="card-lightbox__title"></h3>
          <p class="card-lightbox__meta"></p>
        </div>
      </div>
    `;
    document.body.appendChild(lightboxEl);
    lightboxEl.querySelector(".card-lightbox__backdrop").addEventListener("click", closeLightbox);
    lightboxEl.querySelector(".card-lightbox__close").addEventListener("click", closeLightbox);
    return lightboxEl;
  }

  function closeLightbox() {
    if (lightboxEl) lightboxEl.hidden = true;
  }

  function openLightbox(card) {
    if (!card.imageUrl) return;
    const box = ensureLightbox();
    box.querySelector(".card-lightbox__image").src = card.imageUrl;
    box.querySelector(".card-lightbox__image").alt = card.name || "Gezogene Karte";
    box.querySelector(".card-lightbox__rarity").textContent = card.rarity || "Karte";
    box.querySelector(".card-lightbox__title").textContent = card.name || "Unbekannte Karte";
    box.querySelector(".card-lightbox__meta").textContent = [
      card.setName,
      card.collectorNumber,
      card.language,
      card.condition,
      card.position ? `#${card.position}` : ""
    ].filter(Boolean).join(" - ");
    box.hidden = false;
  }

  function renderCards(payloadOrCards) {
    const cards = normalizeCards(payloadOrCards);
    const payload = Array.isArray(payloadOrCards) ? { cards: payloadOrCards } : (payloadOrCards || {});
    activePayload = payload;
    modal.classList.add("is-showing-result");
    packFoil.hidden = true;
    packConfirm.hidden = true;
    packMessage.hidden = true;
    packResult.innerHTML = "";
    if (!cards.length) {
      packMessage.hidden = false;
      packMessage.textContent = "Für dieses Pack wurden keine Karten gefunden.";
      packResult.hidden = true;
      return;
    }

    packResult.appendChild(createSummaryActions(payload));

    const grid = document.createElement("div");
    grid.className = "pack-result-grid";
    cards.forEach((card) => {
      const item = document.createElement("button");
      item.className = `result-card ${Number(card.animation || 0) > 0 ? "is-hit" : ""}`;
      item.dataset.hitLevel = String(card.animation || 0);
      item.type = "button";
      const image = card.imageUrl
        ? `<img class="result-card__image" src="${escapeHtml(card.imageUrl)}" alt="${escapeHtml(card.name)}">`
        : `<div class="result-card__image" role="img" aria-label="${escapeHtml(card.name)}"></div>`;
      const details = [
        card.setName,
        card.collectorNumber,
        card.language,
        card.condition,
        card.position ? `#${card.position}` : ""
      ].filter(Boolean).map(escapeHtml).join(" &middot; ");

      item.innerHTML = `
        ${image}
        <div class="result-card__body">
          <p class="result-card__rarity">${escapeHtml(card.rarity || "Karte")}</p>
          <p class="result-card__name">${escapeHtml(card.name || "Unbekannte Karte")}</p>
          ${details ? `<p class="result-card__meta">${details}</p>` : ""}
        </div>
      `;
      item.addEventListener("click", () => openLightbox(card));
      grid.appendChild(item);
    });
    packResult.appendChild(grid);
    packResult.hidden = false;
  }

  async function fetchPackDetails(packId) {
    return request(`/my_packs/${encodeURIComponent(packId)}`);
  }

  async function showOpenedPack(packId) {
    try {
      const payload = await fetchPackDetails(packId);
      packMessage.hidden = true;
      modalStatus.textContent = "Gezogene Karten";
      packSubtitle.textContent = "Dein echtes Booster-Ergebnis ist gespeichert.";
      renderCards(payload);
    } catch (error) {
      packMessage.hidden = false;
      packMessage.textContent = error.message;
    }
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  async function playPackReplay(payload) {
    const cards = normalizeCards(payload);
    if (!cards.length) return;
    const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    packFoil.hidden = true;
    packConfirm.hidden = true;
    packMessage.hidden = true;
    packResult.hidden = false;
    packResult.innerHTML = "";
    modalStatus.textContent = "Pack wird ge\u00f6ffnet";
    packSubtitle.textContent = "Replay deiner originalen Packanimation.";

    const stage = document.createElement("div");
    stage.className = "pack-replay-stage";
    stage.innerHTML = `
      <div class="pack-replay-cover">
        ${selectedPack?.cover ? `<img src="${escapeHtml(selectedPack.cover)}" alt="${escapeHtml(selectedPack.editionName || "Booster")}">` : ""}
        <span class="pack-replay-cover__title">${escapeHtml(selectedPack?.editionName || "Online Booster")}</span>
        <span class="pack-replay-cover__tear"></span>
      </div>
      <div class="pack-replay-stack" aria-live="polite"></div>
    `;
    packResult.appendChild(stage);

    await wait(reducedMotion ? 0 : 80);
    stage.querySelector(".pack-replay-cover").classList.add("is-tearing");
    await wait(reducedMotion ? 0 : 860);
    stage.querySelector(".pack-replay-cover").classList.add("is-opened");

    const stack = stage.querySelector(".pack-replay-stack");
    for (const [index, card] of cards.entries()) {
      const item = document.createElement("button");
      item.className = `pack-replay-card ${card.rarity && card.rarity !== "Karte" ? "is-hit" : ""}`;
      item.dataset.hitLevel = String(card.animation || 0);
      item.type = "button";
      item.innerHTML = `
        <span class="pack-replay-card__back">ERTIMA</span>
        ${card.imageUrl ? `<img src="${escapeHtml(card.imageUrl)}" alt="${escapeHtml(card.name)}">` : ""}
        <strong>${escapeHtml(card.name || `Karte ${index + 1}`)}</strong>
      `;
      item.addEventListener("click", () => openLightbox(card));
      stack.appendChild(item);
      await wait(reducedMotion ? 0 : (index < 3 ? 170 : 95));
      item.classList.add("is-revealed");
    }

    await wait(reducedMotion ? 0 : 620);
    modalStatus.textContent = "Gezogene Karten";
    packSubtitle.textContent = "Dein echtes Booster-Ergebnis ist gespeichert.";
    renderCards(payload);
  }

  async function confirmOpening() {
    if (!selectedPack) return;

    packConfirm.disabled = true;
    packConfirm.textContent = "Pack wird ge\u00f6ffnet ...";
    packFoil.classList.add("is-opening");

    try {
      await new Promise((resolve) => window.setTimeout(resolve, 900));
      const payload = selectedPack.status === "opened"
        ? (activePayload || await fetchPackDetails(selectedPack.id))
        : await request(`/my_packs/${encodeURIComponent(selectedPack.id)}/open`, {
            method: "POST",
            body: JSON.stringify({
              animationConfirmed: true,
              customer_id: customerId
            })
          });

      packConfirm.hidden = true;
      packConfirm.disabled = false;
      packMessage.hidden = true;
      await playPackReplay(payload);
      if (selectedPack.status !== "opened") {
        state.activeTab = "opened";
        await loadPacks();
      }
    } catch (error) {
      packConfirm.disabled = false;
      packConfirm.textContent = "Erneut versuchen";
      packMessage.hidden = false;
      packMessage.textContent = error.message;
      packFoil.classList.remove("is-opening");
    }
  }

  refreshButton && refreshButton.addEventListener("click", loadPacks);
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => setActiveTab(button.dataset.packTab));
  });
  modalCloseButtons.forEach((button) => button.addEventListener("click", closeModal));
  packConfirm && packConfirm.addEventListener("click", confirmOpening);
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (lightboxEl && !lightboxEl.hidden) {
      closeLightbox();
      return;
    }
    if (modal && !modal.hidden) closeModal();
  });

  loadPacks();
})();
